const ROUTES = Object.freeze({
    ROOT: () => '/',
    APP: () => templateRoute('/:authToken'),
})

const templateRoute = (template: string, params?: { [name: string]: string | number }, hash?: string) => {
    if (!params) {
        return template;
    }

    let route = template;
    for (const key in params) {
        const toReplace = ':' + key;
        route = route.replace(toReplace, String(params[key]));
    }

    if (hash?.length) {
        hash = `#${ hash }`.replace('##', '#');
    }

    return route + (hash || '');
};


export default ROUTES;
